__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-card-member-apply-root'].baseUrl;
import ModuleContainer from './components/AxpSuppRoot';
import './iguazu-rest/config';
import './iguazu-rpc/config';
import memberProducts from './memberProducts';
memberProducts();
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
  providedExternals: {
    'axp-product-ducks': {
      ...{
        "fallbackEnabled": false
      },
      version: '0.3.3',
      module: require('axp-product-ducks')
    },
    '@americanexpress/product-ducks': {
      ...{
        "fallbackEnabled": false
      },
      version: '1.7.0',
      module: require('@americanexpress/product-ducks')
    },
    'iguazu': {
      ...{
        "fallbackEnabled": false
      },
      version: '3.2.0',
      module: require('iguazu')
    },
    'iguazu-holocron': {
      ...{
        "fallbackEnabled": false
      },
      version: '1.8.2',
      module: require('iguazu-holocron')
    },
    'iguazu-rest': {
      ...{
        "fallbackEnabled": false
      },
      version: '1.11.1',
      module: require('iguazu-rest')
    },
    'iguazu-rpc': {
      ...{
        "fallbackEnabled": false
      },
      version: '1.6.1',
      module: require('iguazu-rpc')
    },
    '@americanexpress/one-xp-client-sdk': {
      ...{
        "fallbackEnabled": false
      },
      version: '0.35.5',
      module: require('@americanexpress/one-xp-client-sdk')
    },
    '@americanexpress/one-experiments': {
      ...{
        "fallbackEnabled": false
      },
      version: '2.8.1',
      module: require('@americanexpress/one-experiments')
    },
    '@americanexpress/one-app-module-wrapper': {
      ...{
        "fallbackEnabled": false
      },
      version: '3.6.3',
      module: require('@americanexpress/one-app-module-wrapper')
    },
    '@americanexpress/myca-essentials': {
      ...{
        "fallbackEnabled": false
      },
      version: '3.3.0',
      module: require('@americanexpress/myca-essentials')
    },
    '@americanexpress/react-ddl': {
      ...{
        "fallbackEnabled": true
      },
      version: '0.3.7',
      module: require('@americanexpress/react-ddl')
    },
    'iguazu-graphql': {
      ...{
        "fallbackEnabled": false
      },
      version: '1.3.0',
      module: require('iguazu-graphql')
    },
    'dayjs': {
      ...{
        "fallbackEnabled": false
      },
      version: '1.11.23',
      module: require('dayjs')
    },
    '@americanexpress/reactlytics': {
      ...{
        "fallbackEnabled": false
      },
      version: '1.4.0',
      module: require('@americanexpress/reactlytics')
    },
    '@emotion/core': {
      ...{
        "fallbackEnabled": false
      },
      version: '10.3.1',
      module: require('@emotion/core')
    },
    '@americanexpress/react-statsig-wrapper': {
      ...{
        "fallbackEnabled": false
      },
      version: '0.5.1',
      module: require('@americanexpress/react-statsig-wrapper')
    }
  }
});
if (global.getTenantRootModule === undefined || global.rootModuleName && global.rootModuleName === 'axp-card-member-apply-root') {
  global.getTenantRootModule = () => ModuleContainer;
  global.rootModuleName = 'axp-card-member-apply-root';
}